import { render, staticRenderFns } from "./inventoryManage.vue?vue&type=template&id=2f140e5e&scoped=true"
import script from "./inventoryManage.vue?vue&type=script&lang=js"
export * from "./inventoryManage.vue?vue&type=script&lang=js"
import style0 from "./inventoryManage.vue?vue&type=style&index=0&id=2f140e5e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f140e5e",
  null
  
)

export default component.exports